interface ITermsOptions {
  /**
   * It converts all characters to lowercase but the first one. Default value is true.
   * For instance: "Call For Papers" will become "Call for papers"
   */
  noCapitalization?: boolean;
  /**
   * It converst first character into uppercase. Default value is false.
   * For instance: "call for papers" will become "Call for papers"
   */
  firstCharUppercase?: boolean;
  /**
   * It conversts the first letter of all words into uppercase.
   * For instance: "research topics" will become "Research Topics"
   */
  capitalLetters?: boolean;
}

const DEFAULT_TERM_OPTIONS = {
  noCapitalization: true,
  firstCharUppercase: false,
  capitalLetters: false
} as ITermsOptions;

function removeCapitalization(text: string): string {
  return `${text.substring(0, 1)}${text.substring(1).toLocaleLowerCase()}`;
}

function firtsCharUppercase(text: string): string {
  return `${text.substring(0, 1).toUpperCase()}${text.substring(1)}`;
}

function capitalizeTerm(text: string): string {
  return text
    .split(" ")
    .map((m) => `${m.charAt(0).toUpperCase()}${m.slice(1).toLowerCase()}`)
    .join(" ");
}

function transformText(text: string, options: ITermsOptions = {}): string {
  const mergedOptions = Object.assign({}, DEFAULT_TERM_OPTIONS, options);

  const transformFunctions = [];

  if (mergedOptions.noCapitalization)
    transformFunctions.push(removeCapitalization);
  if (mergedOptions.firstCharUppercase)
    transformFunctions.push(firtsCharUppercase);
  if (mergedOptions.capitalLetters) {
    transformFunctions.push(capitalizeTerm);
  }

  transformFunctions.forEach((f) => (text = f(text)));
  return text;
}

export { transformText, type ITermsOptions };
